import ClipperPlaceholder from './ClipperPlaceholder.jsx';

export default function IngresoDeRemitos() {
  return (
    <ClipperPlaceholder title="Ingreso de Remitos" category="Operativas" />
  );
}
